<template>
    <div class="modal fade" id="confirmRemoveKeywordP" tabindex="-1" role="dialog" aria-labelledby="confirmRemoveKeywordP" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Save Campaign</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Are you sure, you want to remove this keyword?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                    <button type="button" @click="removeKeyword" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'RemoveKeywordConfirmModal',
    data() {
        return {

        }
    },
    props: {

    },
    methods: {
        removeKeyword() {
            this.$emit('removeKeyword')
        },
    },
}
</script>

<style lang="scss">

</style>
